export default "__VITE_ASSET__dd40d06a__"